import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '@app/guards/auth.guard';
import { RiskRecheckGuard } from '@app/guards/riskRecheck.guard';
import { StrategyGuard } from '@app/guards/strategy.guard';
import { StrategyAdjustComponent } from '@strategy/components/strategy-adjust/strategy-adjust.component';
import { StrategyComponent } from '@strategy/strategy.component';

import { StrategyRiskRecheckComponent } from './components';

const routes: Routes = [
  {
    path: 'strategy',
    canActivate: [AuthGuard, StrategyGuard],
    children: [
      {
        component: StrategyComponent,
        path: ''
      },
      { path: 'adjust', component: StrategyAdjustComponent },
      { path: 'risk-check', component: StrategyRiskRecheckComponent, canActivate: [RiskRecheckGuard] }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StrategyRoutingModule {}
